// rounter doc: https://reactrouter.com/docs/en/v6/upgrading/v5
import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";

import NotFound from "./pages/NotFound";
import Home from "./pages/Home";
import Upload from "./pages/Upload";
import Download from "./pages/Download";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";

import SnackBox from "./lib/SnackBox";
import AlertDialog from "./lib/AlertDialog";
import ScrollToTop from './lib/ScrollToTop';

import ProtectedRoute from './ProtectedRoute';

const App = () => {
  return (

    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/upload" element={<Upload />} />
        <Route path="/download" element={<Download />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        {/* <Route path="/login" element={<Login />} /> */}

        <Route element={<ProtectedRoute />} >
          {/* <Route path="/dashboard" element={<Dashboard />} /> */}
        </Route>

        <Route path="*" element={<NotFound />} />

      </Routes>
      <SnackBox />
      <AlertDialog />
    </BrowserRouter>
  );
};

export default App;
